/**
 * @constant ExportTranslateMapper
 * @description
 * Translation key map for copy the export module raises on its own — the
 * failure toast, and the page chrome stamped onto a generated document.
 *
 * The module is a core service rather than a feature, so it owns these keys
 * directly instead of taking them from a caller; feature-specific copy still
 * reaches the module as already-resolved strings on the request.
 */
export const ExportTranslateMapper = {

    /** Title of the toast raised when an export fails. */
    FAILED_TITLE: () => 'EXPORT.FAILED_TITLE',

    /** Body of the toast raised when an export fails. */
    FAILED_MESSAGE: () => 'EXPORT.FAILED_MESSAGE',

    /** Fallback heading for a document section that carries no title. */
    SECTION_FALLBACK_TITLE: () => 'EXPORT.SECTION',

    /** Footer page counter — takes `current` and `total` parameters. */
    PAGE_OF: () => 'EXPORT.PAGE_OF',

} as const;
